export const locationsData = [
    {
        "name":"PRIVADA 15t",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDOS",
        "transform":"matrix(1.1092 0 0 1 3400.9661 5890.532)",
    },
    {
        "name":"PRIVADA 14t",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDOS",
        "transform":"matrix(1.1092 0 0 1 3570.9661 5390.532)",
    },
    {
        "name":"PRIVADA 13t",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDOS",
        "transform":"matrix(1.1092 0 0 1 3510.9661 4700.532)",
    },
    {
        "name":"PRIVADA 12t",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDOS",
        "transform":"matrix(1.1092 0 0 1 3685.9661 3950.532)",
    },
    {
        "name":"PRIVADA 11t",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDOS",
        "transform":"matrix(1.1092 0 0 1 3785.9661 3570.532)",
    },
    {
        "name":"PRIVADA 22t",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDOS",
        "transform":"matrix(1.1092 0 0 1 1305.9661 3950.532)",
    },
    //txt casas
    {
        "name":"PRIVADA 0c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 1020.6289 820.8673)",
    },
    {
        "name":"PRIVADA 1c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 1220.6289 1140.8673)",
    },
    {
        "name":"PRIVADA 2c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 1430.6289 1570.8673)",
    },
    {
        "name":"PRIVADA 3c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 2320.6289 1370.8673)",
    },
    {
        "name":"PRIVADA 4c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 2390.6289 1890.8673)",
    },
    {
        "name":"PRIVADA 18c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 1590.6289 2000.8673)",
    },
    {
        "name":"PRIVADA 19c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 1330.6289 2400.8673)",
    },
    {
        "name":"PRIVADA 20c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 1330.6289 2960.8673)",
    },
    /* {
        "name":"PRIVADA 20c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 660.6289 3650.8673)",
    },
    {
        "name":"PRIVADA 21c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 660.6289 4300.8673)",
    }, */
    {
        "name":"PRIVADA 5c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 3380.6289 1870.8673)",
    },
    {
        "name":"PRIVADA 6c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 3220.6289 2310.8673)",
    },
    {
        "name":"PRIVADA 7c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 3080.6289 2730.8673)",
    },
    {
        "name":"PRIVADA 8c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 3010.6289 3230.8673)",
    },
    {
        "name":"PRIVADA 9c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 3990.9661 2620.532)",
    },
    {
        "name":"PRIVADA 10c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 3815.9661 3050.532)",
    },
    /* {
        "name":"PRIVADA 16c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 2535.9661 5900.532)",
    },
    {
        "name":"PRIVADA 17c",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDAS",
        "transform":"matrix(1.1092 0 0 1 2235.9661 6440.532)",
    }, */
    {
        "name":"DEPAS",
        "coords":"",
        "shape":"poly",
        "color":"454141",
        "text":"VENDIDOS",
        "transform":"matrix(1.1092 0 0 1 2160.6289 3050.8673)",
    },
    {//privada 0 terr
        "name":"PRIVADA 0",
        "coords":"1414.03 828.18 1310.38 922.27 1271.37 879.05 1167.72 973.14 1008.23 796.44 1028.88 778.08 1034.62 778.08 1189.14 635.04 1217.82 665.25 1270.22 618.59 1333.71 687.82 1308.09 712.3 1414.03 828.18",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 1",
        "coords":"1476.37 895.88 1413.65 827.8 1310.76 921.89 1271.37 879.05 1117.23 1019.04 1179.58 1088.26 1115.7 1146.02 1212.09 1253.11 1109.97 1347.2 1270.99 1523.9 1424.74 1383.15 1463.75 1425.98 1822.51 1098.21 1760.55 1028.98 1682.52 1100.5 1648.1 1059.58 1586.52 991.5 1560.9 1016.36 1498.94 947.51 1461.84 908.89 1476.37 895.88",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 2",
        "coords":"1848.13 1074.11 1463.37 1425.98 1423.97 1383.15 1167.34 1616.84 1229.68 1685.68 1178.43 1733.11 1338.68 1908.28 1287.05 1954.94 1384.58 2062.41 1616.36 1852.06 1654.6 1893.36 2037.07 1542.64 1941.45 1437.08 1969.76 1412.21 1906.27 1342.99 1931.89 1320.04 1835.51 1211.8 1911.62 1143.72 1848.13 1074.11",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 3",
        "coords":"2149.14 1135.31 2146.84 1226.72 2143.97 1228.06 2163.29 1337.63 2199.62 1519.69 2242.46 1519.69 2240.55 1611.1 2475.76 1616.45 2475.76 1657.38 2994.78 1666.17 2996.3 1574.38 2869.71 1571.32 2873.15 1334.19 2848.67 1333.43 2850.2 1188.85 2718.25 1187.32 2719.4 1147.16 2149.14 1135.31",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 4",
        "coords":"2942.38 1665.03 2475 1657 2475 1616.07 2243.61 1611.1 2240.16 1704.04 2231.37 1704.04 2201.92 2034.88 2206.89 2034.88 2204.98 2127.82 3009.31 2141.58 3011.6 1997.39 2918.28 1996.25 2921.72 1810.75 2942.76 1810.75 2942.76 1757.2 2942.38 1665.03",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 5",
        "coords":"3669.07 2119.02 3339.38 2009.25 3368.4 1921.14 3365.96 1919.85 3381.59 1870.51 3384.89 1871.23 3457.18 1643.99 3460.62 1643.99 3489.31 1557.17 3785.72 1656.23 3758.95 1743.43 3790.31 1753.76 3669.07 2119.02",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 6",
        "coords":"3669.07 2119.02 3339 2009.63 3290.42 2145.41 3293.87 2147.7 3188.69 2460.56 3585.31 2591.75 3650.71 2397.46 3706.17 2227.64 3640.38 2206.6 3669.07 2119.02",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 7",
        "coords":"3475.16 2555.03 3178.74 2456.36 3149.29 2544.32 3146.81 2544.04 3130.46 2595.1 3134.04 2596.24 3104.93 2683.16 3096.13 2680.48 3066.68 2766.54 3064.39 2766.54 3047.17 2817.98 3049.85 2819.32 3020.78 2905.38 3350.47 3015.53 3414.73 2821.23 3470.57 2650.65 3447.24 2642.24 3475.16 2555.03",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 8",
        "coords":"3351.24 3015.53 3070.12 2922.59 3021.93 3061.04 3073.18 3078.63 3045.64 3164.31 3095.75 3181.52 3047.17 3318.82 3115.25 3342.54 3086.18 3428.98 3285.45 3495.91 3315.67 3407.94 3328.29 3412.91 3363.86 3306.2 3420.46 3133.71 3371.89 3118.79 3401.34 3032.74 3351.24 3015.53",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 9",
        "coords":"4451.98 2885.49 3727.97 2783.37 3742.5 2677.42 3784.96 2579.89 3858.01 2414.28 3872.54 2322.49 4519.68 2413.52 4506.29 2507.61 4597.7 2519.08 4558.31 2803.26 4464.99 2794.08 4451.98 2885.49",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 10",
        "coords":"4456.96 2886.64 3603.28 2764.24 3589.9 2856.8 3592.57 2968.1 3600.22 3151.69 3587.22 3245.01 4389.64 3357.84 4403.41 3263.75 4494.44 3276.75 4534.98 2992.2 4443.57 2978.43 4456.96 2886.64",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 18",
        "coords":"1379.44 2066.11 1955.13 2273.49 2028.66 2073.31 2089.47 1901.2 2060.21 1889.73 2091.76 1804.25 1848.52 1716.47 1654.6 1893.17 1615.59 1852.44 1379.44 2066.11",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 19",
        "coords":"1892.69 2250.59 1380.37 2065.86 1304.64 2135.85 1342.51 2150.19 1239.24 2437.62 1227.19 2434.17 1227.19 2529.98 1319.56 2564.4 1725.74 2710.7 1757.3 2625.79 1736.07 2617.18 1780.24 2503.02 1841.63 2329.76 1860.56 2337.22 1892.69 2250.59",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
    {//
        "name":"PRIVADA 16",
        "coords":"3181.8 5194.26 2646.54 4603.35 2697.6 4520.16 2885.77 4267.16 2991.91 4387.64 3060.18 4324.53 3368.83 4663.59 3299.99 4724.97 3416.45 4854.63 3266.14 4992.32 3326.95 5060.02 3181.8 5194.26",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 20",
        "coords":"1782.54 2731.93 1732.05 2713.57 1724.6 2710.13 1320.71 2563.83 1293.74 2639.56 1305.79 2647.88 1309.23 2656.77 1346.52 3052.63 1337.34 3088.77 1753.85 3239.08 1819.83 3058.94 1732.63 3025.09 1801.47 2836.91 1751.56 2817.41 1782.54 2731.93",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 17",
        "coords":"3234.58 5253.35 2646.54 4602.77 2595.48 4685.96 2462.95 5001.5 2427.38 5099.03 2875.45 5593.56 2943.72 5532.75 2950.03 5539.06 3041.24 5457.02 3088.29 5413.42 3178.93 5331.95 3167.46 5317.04 3234.58 5253.35",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
    {
        "name":"PRIVADA 21",
        "coords":"1754.43 3240.23 1337.34 3088.77 1313.82 3177.12 1333.33 3184.58 1230.06 3473.72 1210.56 3563.22 1835.89 3788.69 1901.3 3606.25 1814.67 3574.12 1884.66 3386.52 1828.43 3364.72 1859.41 3280.39 1754.43 3240.23",
        "shape":"poly",
        "color":"454141",
        "text":"",
        "transform":"",
    },
]